export const DSIconName = 'DSIcon';

export const DSIconSlots = {
  ICON_WRAPPER: 'root',
  SVG: 'svg',
};
